<template>
  <el-dialog :visible.sync="visible" title="商家样品跟进记录" width="480px" :before-close="handleClose">
    <el-form :model="form" ref="form" label-width="140px">
      <el-form-item label="是否已联系商家">
        <div slot="label" class="flex">
          <explain :content="content" class="ml-6"></explain>
          <p class="ml-4">是否已联系商家</p>
        </div>
        <div class="flex flex-align-center mt-8">
          <el-radio v-model="form.contact_status" label="1">是</el-radio>
          <el-radio v-model="form.contact_status" label="0">否</el-radio>          
        </div>
      </el-form-item>
      <el-form-item label="商家跟进记录">
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入内容"
          maxlength="100"
          show-word-limit
          v-model="form.follow_notes">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="submit" :disabled="isDisabled">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { sampleOrderMerchant } from '@/api/sampleOrder';
import Explain from '@/components/common/explain';
export default {
  components: {
    Explain
  },
  computed: {
    content() {
      return '若设为“已联系商家”，针对“未发货”状态的样品订单会展示【已联系商家】的标识，若设为“未联系商家”，则展示【未联系商家标识】'
    }
  },
  watch: {
    "form": {
      handler(to) {
        if(to.contact_status) {
          this.isDisabled = false
        }else {
          this.isDisabled = true
        }
      },
      deep: true
    }
  },
  data() {
    return {
      visible: false,
      switchValue: false,
      form: {
        contact_status: '',
        follow_notes: ''
      },
      isDisabled: true
    }
  },
  methods: {
    show({sample_sn, contact_status, follow_notes}) {
      this.form.contact_status = contact_status
      this.form.follow_notes = follow_notes
      this.form.sample_sn = sample_sn
      this.visible = true
    },
    async submit() {
      const { code } = await sampleOrderMerchant({...this.form})
      if(code !== 0) return
      this.$message.success('修改成功')
      this.$emit('refreshList')
      this.handleClose()
    },
    handleClose() {
      this.visible = false
      this.switchValue = false
      this.form = {
        contact_status: '',
        follow_notes: ''
      }
      this.$refs.form.resetFields()
    }
  }
}
</script>